export default "__VITE_ASSET__CmsMA$KI__"